import { useQuery, type UseQueryResult } from '@tanstack/react-query'

import type { CurrentUser } from '../api/contracts'

import { authApi } from './auth-api'

/**
 * Profil sorgusunun anahtarı. Dışa veriliyor ki 2FA'yı açıp kapatan mutasyonlar bunu
 * geçersiz kılabilsin — o değişiklik yeni bir token üretmez, yani oturum yükü onu göremez.
 */
export const meQueryKey = ['me'] as const

/**
 * Oturumdaki kullanıcının profili (`GET /app/v1/me`).
 *
 * Oturum yükünün (`AuthProvider`) yerine geçmez, onu tamamlar: yönlendirme ve rol kararları
 * token'dan okunur — her sayfa açılışında bir istek beklemeden — buradan ise token'ın taşıyamadığı
 * alanlar gelir (e-posta, son giriş, müşteri adı) ve token basıldıktan sonra değişmiş olabilecek
 * 2FA durumu.
 */
export function useMe(): UseQueryResult<CurrentUser, Error> {
  return useQuery({
    queryKey: meQueryKey,
    queryFn: () => authApi.me(),
  })
}
